export default function PHP_prepare() {
  return (
    <div>
      <h1>PHP_prepare</h1>
    </div>
  );
}
